import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import { Alarm, Send } from '@material-ui/icons';
import { toast } from '../../../redux/action';
import { cancelSmartResend } from '../../../Component/Analytics/Components/SmartResendDrawer/api';
import { BLUE, GREY_TEXT } from '../AnalyticsV2.styled';

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #1c1c1c;
  white-space: nowrap;
  .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

const CancelLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: ${BLUE};
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
`;

// The resend to non-openers, with the texts and rules of the current page's
// MessageDetails.js: cancelled with the message, resent, or scheduled with a
// Cancel link. Nothing when the message has no resend.
const ResendStatus = ({ message, onChanged }) => {
  const dispatch = useDispatch();
  const [isCancelling, setCancelling] = useState(false);
  const resendTime = message.smartResendScheduleTime;

  if (!resendTime) return null;

  if (message.status === 'cancelled') {
    return <Line>Resend to non-openers cancelled</Line>;
  }

  if (moment.unix(resendTime).isBefore(moment())) {
    return (
      <Line>
        <Send style={{ color: GREY_TEXT }} />
        Resent on {moment.unix(resendTime).format('MM/DD/YY')}
      </Line>
    );
  }

  const handleCancel = async () => {
    setCancelling(true);
    try {
      await cancelSmartResend(message._id);
      dispatch(toast('success', 'Successfully cancelled a smart resend'));
      onChanged();
    } catch (e) {
      dispatch(toast('error', 'Error cancelling a smart resend'));
    }
    setCancelling(false);
  };

  return (
    <Line>
      <Alarm style={{ color: '#E9505C' }} />
      Resend to non-openers scheduled:{' '}
      {moment.unix(resendTime).format('MM/DD/YY [at] hh:mm a')}
      <CancelLink onClick={handleCancel} disabled={isCancelling}>
        {isCancelling ? (
          <>
            Cancelling <CircularProgress size={14} color="inherit" />
          </>
        ) : (
          'Cancel'
        )}
      </CancelLink>
    </Line>
  );
};

export default ResendStatus;
